import { TimelineLite, Power0} from 'gsap';

const animation = (audioFn) => {
    const tl = new TimelineLite();

    tl.eventCallback('onStart', audioFn)
        .set(['.replay-section'], {pointerEvents: 'none'})
        .from('.questions__heading', 1, {alpha: 0, ease: Power0.easeNone })
        .from('.questions__content', 1, {alpha: 0, ease: Power0.easeNone }, '+=.2')
        .from(['#left-hand', '#right-hand'], 1, {y: '+=102%', scale: 0.5, alpha: 0.5, ease: Power0.easeNone }, '+=.3')
        .from('#heart-left-side', 1.5, {x: '-=15', y: '+=110', alpha: 0, scale: 0.4}, '+=.4')
        .from('#heart-right-side', 1.5, {x: '+=45', y: '+=110', alpha: 0, scale: 0.4}, '-=1.5')
        .set('.replay-section', {pointerEvents: 'auto'}, '+=.3')
        .from('.replay-section', 1, {alpha: 0, delay: 0.5, ease: Power0.easeNone}, '+=.3')        
        .from('.legal-info', 1, {alpha: 0, delay: 0.5, ease: Power0.easeNone}, '+=.3')        
} 

export default animation
